import React, { useContext } from 'react';
import { ConfigContext } from '.';
import Empty from '../empty';
const DefaultRenderEmpty = (props) => {
    const { componentName, description } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefix = getPrefixCls('empty');
    switch (componentName) {
        case 'Table':
        case 'List':
            return React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_SIMPLE, description: description });
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return (React.createElement(Empty, { image: Empty.PRESENTED_IMAGE_INFO, description: description, className: `${prefix}-small` }));
        /* istanbul ignore next */
        default:
            // Should never hit if we take all the component into consider.
            return React.createElement(Empty, { description: description });
    }
};
export default DefaultRenderEmpty;
